import { api } from './index';

export const loginUser = (payload: unknown) => api.post('/user/login', payload);
